import "../src/styles/global.scss"
import { autoinject } from "aurelia-framework";
import "./app.scss";
import { NavItems } from "components/comp-navigation/comp-navigation";

@autoinject()
export class App {

	public navItems: NavItems[] = [
        {
            value: "home",
            index: NavIndex.Home
        },
        {
            value: "about",
            index: NavIndex.About
        },
        {
            value: "experience",
            index: NavIndex.Experience
        },
        {
            value: "skills",
            index: NavIndex.Skills
        },
        {
            value: "download",
            index: NavIndex.Cv,
            isExtrnalLink: true,
            route: "assets/files/Johann_Bajada_CV.pdf",
            downloadFileName: "Johann_Bajada_CV.pdf"
        },
        {
            value: "linkedin",
            index: NavIndex.Linkedin,
            isExtrnalLink: true,
            route: "https://www.linkedin.com/in/johann-bajada/"
        },
        {
            value: "mail",
            index: NavIndex.Mail,
            isExtrnalLink: true,
            route: "mailto:johannbajada44@gmail.com"
        }
    ];        //Move to Navigation service

    public skills: { name: string, icon: string, isOthers?: boolean }[] = [
        {
            name: 'HTML',
            icon: 'html'
        },
        {
            name: 'CSS',
            icon: 'css'
        },
        {
            name: 'SASS',
            icon: 'sass'
        },
        {
            name: 'JavaScript',
            icon: 'js'
        },
        {
            name: 'TypeScript',
            icon: 'ts'
        },
        {
            name: 'Angular JS',
            icon: 'angular'
        },
        {
            name: 'Aurelia JS',
            icon: 'aurelia'
        },
        {
            name: 'Git',
            icon: 'git'
        },
        {
            name: 'Responsive Design',
            icon: 'responsive'
        },
        {
            name: 'Jest',
            icon: 'jest'
        },
        {
            name: 'Google Analytics',
            icon: 'ga'
        },
        {
            name: 'Maltese Language',
            icon: 'mt',
            isOthers: true
        },
        {
            name: 'English Language',
            icon: 'en',
            isOthers: true
        },
        {
            name: 'Figma',
            icon: 'figma',
            isOthers: true
        },
        {
            name: 'Visual Studio Code',
            icon: 'vsc',
            isOthers: true
        },
        {
            name: 'Webpack',
            icon: 'webpack',
            isOthers: true
        },
        {
            name: 'SendGrid',
            icon: 'sendgrid',
            isOthers: true
        },
        {
            name: 'Photoshop',
            icon: 'ps',
            isOthers: true
        },
        {
            name: 'Illustrator',
            icon: 'ai',
            isOthers: true
        },
    ]
    public mainSkills = [];
    public otherSkills = [];
    public compNavigation: HTMLElement | null = null;

    public sectionHero: HTMLElement | null = null;
    public sectionAbout: HTMLElement | null = null;
    public sectionExperience: HTMLElement | null = null;
    public sectionSkills: HTMLElement | null = null;
    public theme: string;
    public button: HTMLElement | null = null;
    public copiedText: boolean = false;
    public isPlaylistShowing: boolean;
    
    private _isDragging = false;
    private _offsetX = 52;
    private _offsetY = 113;

    constructor() {}

    attached() {
        document.addEventListener("mousemove", this.onMouseMove);
        document.addEventListener("mouseup", this.onMouseUp);

        this.mainSkills = this.skills.filter(skill => !skill.isOthers)
        this.otherSkills = this.skills.filter(skill => skill.isOthers)
    }

    onNavClick(event) {
        const index = event.detail.navItem.index;

        if (index === NavIndex.Home) {
            this.scrollIntoView(this.sectionHero);
        } else if (index === NavIndex.About) {
            this.scrollIntoView(this.sectionAbout);
        } else if (index === NavIndex.Experience) {
            this.scrollIntoView(this.sectionExperience);
        } else if (index === NavIndex.Skills) {
            this.scrollIntoView(this.sectionSkills);
        }
    }

    scrollIntoView(section: HTMLElement) {
        section.scrollIntoView({ behavior: "smooth" });
    }
 
    detached() {
        document.removeEventListener("mousemove", this.onMouseMove);
        document.removeEventListener("mouseup", this.onMouseUp);
    }

    startDrag(event) {
        this._isDragging = true;
        const e = event.detail.event;
        
        if (this.compNavigation) {
            const rect = this.compNavigation.getBoundingClientRect();
            this._offsetX = e.clientX - rect.left;
            this._offsetY = e.clientY - rect.top;
        }
    }

    onMouseMove = (event: MouseEvent) => {
        if (this._isDragging && this.compNavigation) {
            this.compNavigation.style.left = `${event.clientX - this._offsetX}px`;
            this.compNavigation.style.top = `${event.clientY - this._offsetY}px`;
        }
    };

    onMouseUp = () => {
        this._isDragging = false;
    };

    openLink(link: string) {
        window.open(link, "_blank");
    }

    copyToClipboard(text) {
        this.copiedText = true;
        navigator.clipboard.writeText(text);

        setTimeout(() => {
            this.copiedText = false;
        }, 2000);
    }
    
    showPlaylist() {

        this.isPlaylistShowing = !this.isPlaylistShowing;
    }

    async downloadCv() {
        const response = await fetch("assets/files/Johann_Bajada_CV.pdf");
        const fileBlob = await response.blob();
        const fileUrl = window.URL.createObjectURL(fileBlob);
        const link = document.createElement("a");

        link.href = fileUrl;
        link.download = "Johann_Bajada_CV.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
    }
}

enum NavIndex {
    Home,
    About,
    Experience,
    Skills,
    Linkedin,
    Mail,
    Cv
}